<template>
  <div class="licitacao-esclarecimento-usuario-convidado-tabela">
    <v-data-table
      :headers="colunas"
      :items="itensExibicao"
      :loading="carregandoInterno"
      class="az-table-list"
      hide-actions
    >
      <template v-slot:items="{ item }">
        <tr>
          <td :class="cellClass('dataCadastro')">{{ item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</td>
          <td :class="cellClass('nomeRazaoSocial')">{{ item.nomeRazaoSocial || item.empresa || '--' }}</td>
          <td :class="['text-truncate', cellClass('assunto')]">{{ item.assunto || '--' }}</td>
          <td :class="cellClass('possuiAnexo')">{{ item.possuiAnexo ? 'Sim' : 'Não' }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span :class="cellClass('processo')" v-bind="attrs" v-on="on">{{ item.processo || '--' }}</span>
              </template>
              <span>{{ item.objeto || 'Nenhum objeto' }}</span>
            </v-tooltip>
          </td>
          <td :class="cellClass('edital')">{{ item.edital || '--' }}</td>
          <td :class="cellClass('orgao')">{{ item.orgao || '--' }}</td>
          <td :class="cellClass('situacao')">{{ item.situacao || '--' }}</td>
          <td :class="cellClass('acoes')" style="width: 80px;">
            <a @click.prevent="$emit('abrir-visualizacao', item)" title="Visualizar">
              <v-icon>search</v-icon>
            </a>
            <a title="Responder" v-if="item.situacao !== 'RASCUNHO'" @click.prevent="$emit('abrir-resposta', item)">
              <v-icon>reply</v-icon>
            </a>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <az-ops title="Nenhum esclarecimento encontrado."
                message="Nenhum registro disponível para o usuário convidado."/>
      </template>
    </v-data-table>

    <div class="text-xs-center" v-if="pageCount > 1" style="margin-top: 16px;">
      <v-pagination v-model="paginaInterna" :length="pageCount" @input="emitirMudancaPagina"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { actionTypes, mutationTypes } from '@/commons/constants'

export default {
  name: 'LicitacaoEsclarecimentoImpugnacaoUsuarioConvidadoTabela',
  props: {
    filtros: { type: Object, default: () => ({}) },
    tipo: { type: String, default: null },
    itens: { type: Array, default: () => [] }, // fallback, overriden by internal fetch
    carregando: { type: Boolean, default: false }
  },
  data() {
    return {
      paginaInterna: 1,
      tamanho: 10,
      total: 0,
      itensInternos: [],
      carregandoInterno: false,
      colunas: [
        { text: 'Data', value: 'dataCadastro' },
        { text: 'Fornecedor', value: 'nomeRazaoSocial' },
        { text: 'Assunto', value: 'assunto' },
        { text: 'Possui Anexo', value: 'possuiAnexo' },
        { text: 'Processo', value: 'processo' },
        { text: 'Edital', value: 'edital' },
        { text: 'Órgão', value: 'orgao' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'acoes', sortable: false, align: 'center' }
      ]
    }
  },
  computed: {
    pageCount() {
      return this.tamanho > 0 ? Math.max(1, Math.ceil(this.total / this.tamanho)) : 0
    },
    itensExibicao() {
      return this.itensInternos
    }
  },
  watch: {
    filtros: {
      handler() {
        this.paginaInterna = 1
        this.carregarLista()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([actionTypes.BUSCAR_ESCLARECIMENTOS_USUARIO_CONVIDADO]),

    emitirMudancaPagina() {
      this.$emit('change-page', this.paginaInterna)
      this.carregarLista()
    },

    async carregarLista() {
      this.carregandoInterno = true
      try {
        const filtrosAtivos = {}
        Object.keys(this.filtros || {}).forEach(k => {
          const v = this.filtros[k]
          if (v !== null && v !== undefined && String(v).trim() !== '') {
            filtrosAtivos[k] = v
          }
        })

        const params = {
          usuarioId: this.$store.state.loki.user.id,
          tipo: this.tipo || (this.filtros && this.filtros.tipo) || 'ESCLARECIMENTO',
          filtros: filtrosAtivos,
          page: this.paginaInterna - 1,
          size: this.tamanho
        }

        const data = await this[actionTypes.BUSCAR_ESCLARECIMENTOS_USUARIO_CONVIDADO](params)
        if (data) {
          this.itensInternos = data.items || []
          this.total = (data.totalElements !== undefined) ? data.totalElements : (data.total || this.itensInternos.length)
          if (data.page !== undefined) this.paginaInterna = data.page + 1
          else if (data.number !== undefined) this.paginaInterna = data.number + 1
        } else {
          this.itensInternos = []
          this.total = 0
        }
      } catch (e) {
        this.$store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, 'Erro ao carregar esclarecimentos do usuário convidado')
      } finally {
        this.carregandoInterno = false
      }
    },
    cellClass(field) {
      const col = this.colunas.find(col => col.value === field)
      const align = col && col.align ? String(col.align).toLowerCase() : null
      if (align === 'center') return 'text-xs-center'
      if (align === 'end' || align === 'right') return 'text-xs-right'
      return 'text-xs-left'
    }
  },
  mounted() {
    this.carregarLista()
  }
}
</script>
